export const ProductItemFragment = /* GraphQL */ `
    __typename
    id
    name
    sku
    url_key
    stock_status
    is_set
    ppum
    small_image {
        __typename
        url
    }
    thumbnail {
        url
    }
    swatch_image_data {
        __typename
        url
        label
    }
    categories {
        name
        url_path
        breadcrumbs {
            category_id
            category_name
        }
    }
    price {
      regularPrice {
        amount {
          currency
          value
        }
      }
    }
    price_range {
        __typename
        minimum_price {
            __typename
            regular_price {
                __typename
                value
                currency
            }
            final_price {
                __typename
                value
                currency
            }
            discount {
                __typename
                amount_off
            }
        }
        maximum_price {
            __typename
            final_price {
                __typename
                value
                currency
            }
            regular_price {
                __typename
                value
                currency
            }
        }
    }
`
